module.exports = __webpack_public_path__ + "static/transactions-min-min-9dda76d13f680974c33bc736d1e5861f.png";